<div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header" mat-dialog-title>
    {{ 'WIDGETS.SETTINGS' | translate }}
</div>

<mat-dialog-content style="padding-left: 1vw; padding-right: 1vw; margin-top: 1vh; ">
    <h1>{{ 'WIDGETS.NEW_WIDGET'|translate }}</h1>
    <div class="container mat-elevation-z3 g-0" style="padding: 1vw; background-color: aliceblue; border-radius: 10px;">
        <mat-select (selectionChange)="typeOfWidgetChanged($event.value)" [(ngModel)]="selectedWidgetKey"
                    [placeholder]="'WIDGETS.SELECT_WIDGET_TYPE'|translate"
                    style="font-weight: 600;"
        >
            <mat-option *ngFor="let item of widgetsSet " [value]="item" style="font-weight: 500;">
                {{ ('WIDGETS.WIDGETS_TITLES.' + item)| translate }}
            </mat-option>
        </mat-select>
    </div>
    <ng-container *ngComponentOutlet="widgetSettingsComponent; inputs: {widget:widget};"></ng-container>
</mat-dialog-content>
<app-button-group-save-cancel
        (actionEvent)="updateSettings($event)"
        [formState]="formState"
        [saveLabel]="'WIDGETS.CREATE'"
        data-action="updateSettings"
></app-button-group-save-cancel>      